var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0462 10.6295L15.3779 8.62018L14.3382 8.18033C14.2531 8.13316 14.1811 8.06548 14.1287 7.98344C14.0763 7.9014 14.0453 7.80758 14.0383 7.7105V4.65157C14.0383 3.69191 13.3286 2.55231 12.4689 2.11246C12.169 1.96251 11.8091 1.96251 11.5092 2.11246C10.6595 2.55231 9.94978 3.7019 9.94978 4.66157V7.72049C9.94978 7.90043 9.80983 8.11036 9.64989 8.19033L3.95189 10.6395C3.32211 10.8994 2.81229 11.6891 2.81229 12.3689V13.6884C2.81229 14.5381 3.45206 14.958 4.24178 14.6181L9.25003 12.4588C9.63989 12.2889 9.95978 12.4988 9.95978 12.9287V15.8376C9.95978 16.0676 9.82982 16.3974 9.66988 16.5574L7.35069 18.8866C7.11078 19.1265 7.00082 19.5963 7.11078 19.9362L7.56062 21.2957C7.74056 21.8855 8.41032 22.1654 8.96013 21.8855L11.3393 19.8862C11.6992 19.5763 12.289 19.5763 12.6488 19.8862L15.028 21.8855C15.5778 22.1554 16.2476 21.8855 16.4475 21.2957L16.8973 19.9362C17.0073 19.6063 16.8973 19.1265 16.6574 18.8866L14.3382 16.5574C14.1683 16.3974 14.0383 16.0676 14.0383 15.8376V12.9287C14.0383 12.4988 14.3482 12.2989 14.7481 12.4588L19.7563 14.6181C20.5461 14.958 21.1858 14.5381 21.1858 13.6884V12.3689C21.1858 11.6891 20.676 10.8994 20.0462 10.6295Z",
    fill: "#0061AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAir);
export default __webpack_public_path__ + "static/media/air.574c9f3a97356ea8427fde80db9787d1.svg";
export { ForwardRef as ReactComponent };